export type KeyMirror = {
  [key: string]: string | null;
};

export type Result = {
  [key: string]: string;
};
/**
 * Helper function to create an object which has values mirroring its key
 * Usage:
 * keyMirror({
 *   FIRST_KEY: null,
 *   SECOND_KEY: null,
 * })
 *
 * returns:
 * {
 *   FIRST_KEY: 'FIRST_KEY',
 *   SECOND_KEY: 'SECOND_KEY',
 * }
 */
export default <T extends KeyMirror>(keyList: T): Result =>
  Object.keys(keyList).reduce(
    (res, key) => ({ ...res, [key]: key }),
    {} as Result,
  );
